export default __webpack_public_path__ + "static/char-s-20-zh-Hant-da8fad515eb2a91b7839ddc8d186871b.webp";